import { createAction, props } from "@ngrx/store";
import { SignatureGroup } from "../../models/signature-group";

export const findSignatureGroupAct = createAction('findSignatureGroupEffect', props<{ id: number }>());
export const loadSignatureGroupByIdAct = createAction('loadSignatureGroupByIdEffect', props<{ signatureGroup: SignatureGroup }>());

export const resetSignatureGroupAct = createAction('resetSignatureGroupEffect');

export const updateSignatureGroupAct = createAction('updateSignatureGroupEffect', props<{ signatureGroupUpdated: SignatureGroup }>());
export const updateSuccessSignatureGroupAct = createAction('updateSuccessSignatureGroupEffect', props<{ signatureGroupUpdated: SignatureGroup }>());

export const saveSignatureGroupAct = createAction('saveSignatureGroupEffect', props<{ signatureGroupNew: SignatureGroup }>());
export const saveSuccessSignatureGroupAct = createAction('saveSuccessSignatureGroupEffect', props<{ signatureGroupNew: SignatureGroup }>());

export const setViolationsSignatureGroupAct = createAction('setViolationsSignatureGroupEffect', props<{ signatureGroupForm: SignatureGroup, violations: {} }>());
export const showMsgErrorAct = createAction('showMsgErrorEffect', props<{ error: any }>() );

